export function getAgentConfigSectionDomId(sectionId) {
  return `agent-config-section-${sectionId}`;
}
